import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-950 pt-20">
      {/* Header */}
      <div className="bg-gray-900 border-b border-yellow-500/20 py-8">
        <div className="container mx-auto px-4">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center space-x-2 text-gray-400 hover:text-yellow-400 transition-colors duration-200 mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück zur Startseite</span>
          </button>
          
          <div className="text-center">
            <span className="inline-block text-yellow-500 font-semibold text-sm uppercase tracking-wider mb-3">
              Rechtliches
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-red-500 mb-6">
              Impressum
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <div className="bg-gray-900 rounded-2xl p-8 md:p-12 border border-yellow-500/20 text-gray-300 leading-relaxed">
          
          <section className="mb-10">
            <div className="bg-gray-800 p-8 rounded-lg mb-6 border border-yellow-500/20">
              <h2 className="text-2xl font-bold text-white mb-4">Balazs Dach & Abbruch Service UG (haftungsbeschränkt)</h2>
              <p className="mb-2"><strong className="text-white">Vertreten durch den Geschäftsführer:</strong> Robert Balazs</p>
              <p className="mb-2">Oesterheidestraße 14</p>
              <p className="mb-4">44892 Bochum</p>
              <p className="mb-4">Deutschland</p>
              <p className="mb-2"><strong className="text-white">Telefon:</strong> 01578 1140651</p>
              <p><strong className="text-white">E-Mail:</strong> dachdeckerjanek691@gmail.com</p>
            </div>

            <h3 className="text-xl font-semibold text-yellow-400 mb-3">Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:</h3>
            <p className="mb-6">Unternehmensnummer: 3615 4009 7729 001</p>

            <h3 className="text-xl font-semibold text-yellow-400 mb-3">Gesetzliche Berufsbezeichnung:</h3>
            <p className="mb-2">Dachdeckermeister</p>
            <p className="mb-6">Verliehen in: Rumänien</p>

            <h3 className="text-xl font-semibold text-yellow-400 mb-3">Handwerkskammer / Eintragung in die Handwerksrolle:</h3>
            <p className="mb-2">Handwerkskammer für Dortmund</p>
            <p className="mb-6">71878254 Betriebsnummer</p>

            <h3 className="text-xl font-semibold text-yellow-400 mb-3">Handelsregister:</h3>
            <p className="mb-2">Eingetragen im Handelsregister des Amtsgerichts Bochum</p>
            <p className="mb-6">Handelsregisternummer: HRB 22648</p>

            <h3 className="text-xl font-semibold text-yellow-400 mb-3">Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV:</h3>
            <p className="mb-2">Robert Balazs</p>
            <p className="mb-6">Oesterheidestraße 14, 44892 Bochum</p>
          </section>

          <section className="mb-10">
            <h2 className="text-3xl font-bold text-white mb-6">Haftung für Inhalte</h2>
            <p className="mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
            </p>
            <p className="mb-4">
              Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen dauerhaft zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mb-6">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-3xl font-bold text-white mb-6">Haftung für Links</h2>
            <p className="mb-4">
              Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
            </p>
            <p className="mb-4">
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            </p>
            <p className="mb-6">
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-3xl font-bold text-white mb-6">Urheberrecht</h2>
            <p className="mb-4">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
            </p>
            <p className="mb-6">
              Beiträge Dritter sind als solche gekennzeichnet.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-3xl font-bold text-white mb-6">Online-Streitbeilegung</h2>
            <p className="mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300 underline">https://ec.europa.eu/consumers/odr/</a>
            </p>
            <p className="mb-6">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};
